import * as API_CONSTANT from '../constants'

import { report_handler } from '../../../handlers'

export const getVehicleInfoByVID = (vid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/getInfo`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vid
        })
    })
    .then(res => res.json())
)

export const getVehicleInfoBatch = (vids) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/batch/getInfo`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vids
        })
    })
    .then(res => res.json())
)

export const getVehicleGroupByVHCGID = (vhcgid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/getGroup`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vhcgid
        })
    })
    .then(res => res.json())
)

export const getVehicleStateByPlate = (plate) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/state/get/plate`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            plate
        })
    })
    .then(res => res.json())
)

export const getVehicleByPlate = (plate) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/get/plate`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            plate
        })
    })
    .then(res => res.json())
)

export const getVehicleGroupBatch = (vhcgids) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/batch/getGroup`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vhcgids
        })
    })
    .then(res => res.json())
)

export const getVehicleLogByTimeFrameSync = (vid, startTime, endTime) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/log/timeframe/get/sync`, {
      method: 'POST',
      headers: API_CONSTANT.headers,
      body: JSON.stringify({
        vid, 
        startTime, 
        endTime
      })
    })
    .then(res => res.json())
    .then(res => report_handler.fetchWithJSONConvertor(res, 'vehicleLogs', 5000))
  )

export const getMDVRLogByTimeFrameSync = (vid, startTime, endTime) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/mdvr/log/timeframe/get/sync`, {
      method: 'POST',
      headers: API_CONSTANT.headers,
      body: JSON.stringify({
        vid, 
        startTime, 
        endTime
      })
    })
    .then(res => res.json())
    .then(res => report_handler.fetchWithJSONConvertor(res, 'mdvrLogs', 5000))
  )

export const getVehicleDerivativeLogByTimeFrameSync = (vid, startTime, endTime) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/log/derivative/timeframe/get/sync`, {
      method: 'POST',
      headers: API_CONSTANT.headers,
      body: JSON.stringify({
        vid, 
        startTime, 
        endTime
      })
    })
    .then(res => res.json())
    .then(res => report_handler.fetchWithJSONConvertor(res, 'vehicleDerivativeLogs', 7000))
  )

export const getVehicleGeoStateLogByTimeFrameSync = (vid, startTime, endTime) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/log/geoState/timeframe/get/sync`, {
      method: 'POST',
      headers: API_CONSTANT.headers,
      body: JSON.stringify({
        vid, 
        startTime, 
        endTime
      })
    })
    .then(res => res.json())
  )

export const getVehicleEventLogByTimeFrameSync = (vid, startTime, endTime) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/log/event/timeframe/get/sync`, {
      method: 'POST',
      headers: API_CONSTANT.headers,
      body: JSON.stringify({
        vid, 
        startTime, 
        endTime
      })
    })
    .then(res => res.json())
  )

export const getVehicleEventLogsByTimeFrameSync = () => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/eventLog/timeframe/get/sync`, {
      method: 'POST',
      headers: API_CONSTANT.headers,
      body: JSON.stringify({})
    })
    .then(res => res.json())
  )
export const updateVehicleEventLogInfo = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/eventLog/update`, {
      method: 'POST',
      headers: API_CONSTANT.headers,
      body: JSON.stringify(items)
    })
    .then(res => res.json())
  )

export const getVehicleECULogByTimeFrameSync = (vid, startTime, endTime) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/log/ecu/timeframe/get/sync`, {
      method: 'POST',
      headers: API_CONSTANT.headers,
      body: JSON.stringify({
        vid, 
        startTime, 
        endTime
      })
    })
    .then(res => res.json())
  )

  export const getVehicleAddressByVID = (vid, lat, lon) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/address/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vid,
            lat,
            lon
        })
    })
    .then(res => res.json())
)

  export const getVehicleAddressBatchByVIDS = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/address/batch/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(
            items
        )
    })
    .then(res => res.json())
)

export const createVehicle = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/create`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(
            items
        )
    })
    .then(res => res.json())
)

export const updateVehicle = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/update`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(
            items
        )
    })
    .then(res => res.json())
)

export const getAllVehiclePackages = () => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/package/get/all`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({})
    })
    .then(res => res.json())
)

export const createVehicleGroup = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/group/create`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(
            items
        )
    })
    .then(res => res.json())
)

export const updateVehicleGroup = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/group/update`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(
            items
        )
    })
    .then(res => res.json())
)

export const createVehicles = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/bulk/create`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(
            items
        )
    })
    .then(res => res.json())
)

export const unassignVehicleFromGroup = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/group/unassign`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(
            items
        )
    })
    .then(res => res.json())
)

export const getEventCountByTimeframe = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vehicle/event/count/timeframe/get/sync`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(
            items
        )
    })
    .then(res => res.json())
)